module.exports = __webpack_public_path__ + "0ffc42226463b188909a4fd221bd2060.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-44.cur
// module id = 459
// module chunks = 0